import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormatQuote } from '@mui/icons-material';
import { testimonialCardStyles } from './TestimonialCard.styles';

const TestimonialCard = ({ title, review, name, location }) => {
  return (
    <Box sx={testimonialCardStyles.card}>
      <Typography sx={testimonialCardStyles.title}>{title}</Typography>
      <Typography sx={testimonialCardStyles.review}>{review}</Typography>
      <Box sx={testimonialCardStyles.iconContainer}>
        <FormatQuote sx={testimonialCardStyles.icon} />
      </Box>
      <Box sx={testimonialCardStyles.bottomInfo}>
        <Typography sx={testimonialCardStyles.name}>{name}</Typography>
        <Typography sx={testimonialCardStyles.location}>{location}</Typography>
      </Box>
    </Box>
  );
};

export default TestimonialCard;

